import axiosInstance from "../../../../lib/axios"; 

//InsertUpdate Api
export async function InsertUpdate(payload){
    try{
        return await axiosInstance.post('TrnRctVchr/ManageTrnRctVchrDtl',payload)
    }catch(error){
        return error;
    }
}

//fetchResident Api
export async function fetchResident(payload){
    try{
        return await axiosInstance.post('ResidentMst/getAllResidentMstDashBoard',payload)
    }catch(error){
        return error;
    }
}
//fetchBank Api
export async function fetchBank(payload){
    try{
        return await axiosInstance.post('MstBank/getMstBankdrp',payload)
    }catch(error){
        return error;
    }
}

//TrnRctVchr Flag P=Pervoius/N-Next/D-Delete/L-LAst/R-Retrive
export async function fetchPNDLR(payload){
    try{
        return await axiosInstance.post('TrnRctVchr/RetriveTrnRctVchrAll',payload)
    }catch(error){
        return error;
    }
}

//stepper-2 Table Data
export async function getTableData(payload){
    try{
        return await axiosInstance.post('TrnRctVchr/GetTrnRctVchrdtlAll',payload)
    }catch(error){
        return error;
    }
}

  //email
export async function SendEmailReceipt(payload){
    try{
        return await axiosInstance.post('EmailRequest/SendEmail',payload)
    }catch(error){
        return error;
    }
}

//getPropId Acording to BookId  
  export async function GetReportTrnBooking(payload){
    try{
        return await axiosInstance.post('TrnBooking/GetReportTrnBooking',payload)
    }catch(error){
        return error;
    }
}